import type { CustomerProps } from '@/repositories/auth/AuthRepository.types';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

export const useGetAccount = () => {
  const authToken = getCookie(authKeys.authToken);
  return useQuery({
    queryKey: ['customer', 'account'],
    queryFn: getAccount,
    enabled: !!authToken,
  });
};

const getAccount = async () => {
  const { data } = await api.get<Account>(apiConfig.routes.auth.account);
  return data;
};

type Account = Pick<
  CustomerProps,
  'id' | 'name' | 'email' | 'phone' | 'document'
>;
